import { loopRequest } from '../../lib/request';

export const loopSearch = (searchQuery: string) =>
  loopRequest(`/Loop54/search?${searchQuery}`);
export const quickSearch = (searchQuery: string | string[]) =>
  loopRequest(`/Loop54/search/quick/?${searchQuery}`);
